<div class="wrapper m-a">
  <svg
    width="100%"
    [attr.height]="topHeightPx + bottomHeightPx + 'px'"
    class="border-radius-4"
    #svgElement>
    <!-- Define a mask to create the transparent line effect -->
    <mask id="cut-out-mask">
      <!-- Full white rectangle (the base) -->
      <rect width="100%" height="100%" fill="white" />

      <!-- Transparent line -->
      <line
        [attr.x1]="lineOffsetX"
        [attr.y1]="topHeightPx"
        [attr.x2]="svgWidth - lineOffsetX"
        [attr.y2]="topHeightPx"
        stroke="black"
        stroke-width="2"
        stroke-dasharray="1, 5"
        stroke-linecap="round" />

      <!-- Cutouts on side-->
      <path
        [attr.transform]="leftCutoutTransform()"
        fill="black"
        d="M 0,22 C 0,16.5 6,16.5 6,10.999999 6,5.4999999 0,5.4999999 0,0 Z" />

      <path
        [attr.transform]="rightCutoutTransform()"
        fill="black"
        d="M 6,22 C 6,16.5 0,16.5 0,10.999999 0,5.5 6,5.5 6,0 Z" />
    </mask>

    <!-- Rectangle with the mask applied -->
    <rect width="100%" height="100%" x="0" y="0" fill="white" mask="url(#cut-out-mask)" />
  </svg>

  <div
    class="ticket-top-part color-dark"
    [style.height]="topHeightPx + 'px'"
    [style.width]="svgWidth + 'px'">
    <ng-container *ngTemplateOutlet="topTemplate" />
  </div>

  <div
    class="ticket-bottom-part color-dark"
    [style.top]="topHeightPx + 'px'"
    [style.height]="bottomHeightPx + 'px'"
    [style.width]="svgWidth + 'px'">
    <ng-container *ngTemplateOutlet="bottomTemplate" />
  </div>
</div>
